<template>
  <div v-if="isValid" class="mt-2 -mx-2">
    <button
      type="button"
      class="primary m-0 border border-gray-100"
      :disabled="!canNavigate"
      @click="navigate"
    >
      <font-awesome-icon icon="arrow-right" class="mr-2" />
      {{ widgetData.label }}
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { isValidInternalRoute } from './types.js';

const props = defineProps({
  widgetData: {
    type: Object,
    required: true
  },
  messageId: {
    type: String,
    default: null
  },
  conversationId: {
    type: String,
    default: null
  }
});

const router = useRouter();

// Validate widget data structure
const isValid = computed(() => {
  if (!props.widgetData) {
    return false;
  }
  
  const { label, route } = props.widgetData;
  
  // Require non-empty label
  if (typeof label !== 'string' || label.trim().length === 0) {
    return false;
  }
  
  // Require valid internal route
  if (!route || !isValidInternalRoute(route)) {
    return false;
  }
  
  return true;
});

// Check if navigation is possible (always true if valid, but kept for future extensibility)
const canNavigate = computed(() => isValid.value);

// Navigate to the route
const navigate = () => {
  if (!canNavigate.value) {
    return;
  }
  
  try {
    router.push(props.widgetData.route);
  } catch (error) {
    console.error('[ChatWidgetLink] Navigation error:', error);
  }
};
</script>

<style scoped>
/* Component uses Tailwind classes, no additional styles needed */
</style>
